import React from 'react'
import { Trans } from 'react-i18next'
import { AccentText } from './AccentText'

/**
 * Renders a translated i18n key with <accent> token support.
 * Usage: <RichText i18nKey="some.key" />
 */
export function RichText({ i18nKey, className, as: Tag = 'p', ...rest }) {
    return (
        <Tag className={className} {...rest}>
            <Trans
                i18nKey={i18nKey}
                components={{ accent: <AccentText /> }}
            />
        </Tag>
    )
}
